// --- SaniQ ---
import {deserializeItem} from "../index";
import {
  DeserializedRecord,
  deserializeManyRelationship,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIManyRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../Helpers";
import {deserializeSurvey, Survey} from "../Survey";
import {Cron, defaultCron, parseMultilineCron} from "helpers/forms/Cron";
import {parseOptionalISO} from "helpers/Parser";

interface Schedule extends DeserializedRecord {
  cron: Cron[];
  subject: DeserializedRecord;
}

interface PatientSurvey extends DeserializedRecord<"patient_survey"> {
  deletedAt?: Date;
  hasHistory: boolean;
  latestBackdateAt?: Date;
  endDate?: Date;
  startDate?: Date;
  schedules: Schedule[];
  sessionPending: boolean;
  sessions: DeserializedRecord[];
  survey: Survey;
  visiteEntryId?: number;
}

interface ScheduleData extends JSONAPIRecord {
  attributes: {
    cron: string;
  }
  relationships: {
    subject: JSONAPISingleRelationship;
  }
}

const deserializeSchedule: Deserializer<Schedule, ScheduleData> = (data, included) => {
  const cron= parseMultilineCron(data.attributes.cron, defaultCron);
  const subject = deserializeSingleRelationship(data.relationships.subject, included);

  return {
    ...deserializeItem(data),
    cron: cron,
    subject: subject
  };
};

interface PatientSurveyData extends JSONAPIRecord {
  relationships: {
    schedules: JSONAPIManyRelationship;
    sessions: JSONAPIManyRelationship;
    survey: JSONAPISingleRelationship;
  }
}

const deserializePatientSurvey: Deserializer<PatientSurvey, PatientSurveyData> = (data, included) => {
  const schedules = deserializeManyRelationship(data.relationships.schedules, included, deserializeSchedule);
  const sessions = deserializeManyRelationship(data.relationships.sessions, included);
  const survey = deserializeSingleRelationship(data.relationships.survey, included, deserializeSurvey);

  return {
    ...deserializeItem(data),
    endDate: parseOptionalISO(data.attributes.end_date),
    startDate: parseOptionalISO(data.attributes.start_date),
    schedules: schedules,
    sessions: sessions,
    survey: survey
  };
};

export {
  deserializePatientSurvey,
  PatientSurvey
};
